export const USADateFormat = 'MM/DD/YYYY';
export const USADateFormatShorten = 'MM/DD/YY';
export const USADateFormatShort = 'M/D/YY';
export const USADateShortDescriptiveFormat = 'MMM D, YYYY'; // example: Jan 20, 2021

export const USATimeFormatShort = 'hh:mm A';
export const USATimeFormatAmPm = 'h:mm A';
export const USATimeFormatAmPmCompact = 'h:mmA';

export const USADateTimeFormat = `MM/DD/YYYY hh:mm A`;
export const USADateFullTimeFormat = `MM/DD/YYYY hh:mm:ss A`;
export const USADateTimeFormatAmPm = 'MM/DD/YYYY h:mm A';
export const USADateFullTimeFormatAmPm = 'MM/DD/YYYY hh:mm:ss A';
export const USADateTimeFormatAmPmSmall = 'MM/DD/YYYY h:mm a';
export const USADateTimeFormatAmPmCompact = `${USADateFormat} ${USATimeFormatAmPmCompact}`;
export const USADateTimeFormatAmPmCompactSmall = 'MM/DD/YYYY h:mma';

export const apiDateFormat = 'YYYY-MM-DD';
export const apiTimeFormat = 'HH:mm:ss';
export const apiDateTimeFormat = `${apiDateFormat} ${apiTimeFormat}`;
